export const projectData = {
  name: "Siddha Sky",
  location: "Siddha Sky, Wadala GTB Nagar",

  bannerImg: [
    "/Images/BANNER/1.jpg",
    "/Images/BANNER/2.jpg",
    "/Images/BANNER/3.jpg",
  ],

  overview: `Welcome to Siddha Sky, Mumbai’s first ever Sky Island in the thriving hub of Wadala.
Experience premium 2, 3 & 4 BHK residences at the iconic Altaire Collection, crafted for elevated living.
Indulge in 25 plus rooftop amenities, including a spectacular 400 ft high Rooftop Skywalk with panoramic city views.
Relax at the Sky Bar, unwind in expansive green spaces and embrace a lifestyle above the ordinary.
Seamless connectivity, futuristic infrastructure and unmatched luxury — all starting from ₹2.05 Cr* onwards.
Schedule your free site visit today and rise to a life truly elevated.`,

  highlights: [
    "Mumbai's First Rooftop Skywalk",
    "5 Towers 39 Storey Each",
    "60 Plus Exquisite Amenities",
    "4+ Acres Of Open Spaces",
    "22,000 Sq Ft Clubhouse",
    "Seamless Connectivity",
  ],

  configurations: [
    { type: "2 BHK", area: "717", price: "₹ 2.05 Cr* ++" },
    { type: "2 BHK", area: "737", price: "₹ 2.10 Cr* ++" },
    { type: "3 BHK", area: "916", price: "₹ 2.60 Cr* ++" },
    { type: "3 BHK", area: "945", price: "₹ 2.70 Cr* ++" },
    { type: "3 BHK", area: "954", price: "₹ 2.72 Cr* ++" },
    { type: "4 BHK", area: "1374", price: "₹ 4.00 Cr* ++" },
  ],

  floorPlan: [
    "/Images/FLOOR PLAN/master plan.jpg",
    "/Images/FLOOR PLAN/4 BHK.jpg",
  ],

  amenities: [
    { title: "Rooftop Infinity Edge Pool", img: "/Images/AMENITIES/1.jpg" },
    { title: "Sky Jog with Nature", img: "/Images/AMENITIES/2.jpg" },
    { title: "Yoga & Meditation Zone", img: "/Images/AMENITIES/3.jpg" },
    { title: "Entrance Lobby", img: "/Images/AMENITIES/4.jpg" },
    { title: "Kids' Play Area", img: "/Images/AMENITIES/5.jpg" },
    { title: "Sky Lounge", img: "/Images/AMENITIES/6.jpg" },
  ],
  gallary: [
    "/Images/GALLERY/1.jpg",
    "/Images/GALLERY/2.jpg",
    "/Images/GALLERY/3.jpg",
    "/Images/GALLERY/4.jpg",
    "/Images/GALLERY/5.jpg",
    "/Images/GALLERY/6.jpg",
  ],

  connectivityData: [
    {
      title: "Connectivity",
      items: [
        "GTB Monorail - 01 Min",
        "GTB Railway Station – 03 Min",
        "Eastern Freeway - 05 Min",
        "Sion Railway Station - 08 Min",
        "BKC - 10 Min",
      ],
    },
    {
      title: "Education Hub",
      items: [
        "Don Bosco High School - 04 Min",
        "Dhirubhai Ambani International School - 20 Min",
      ],
    },
    {
      title: "Healthcare",
      items: ["Tata Memorium Hospital - 15 Min", "Hinduja Hospital - 20 Min"],
    },
    // {
    //   title: "Malls / Shopping",
    //   items: [
    //     "Carnival Cinemas - 300 Mts",
    //     "D Mart (LBS) – 400 Mts",
    //     "Galleria Powai – 2.7 Km",
    //     "R-City Ghatkopar – 3.6 Km",
    //   ],
    // },
  ],
};
